module.exports = __webpack_public_path__ + "img/freight_yard2_3.76df03d6.png";